export default __webpack_public_path__ + "static/media/high-voltage.21dadbb3.png";